




















































































































































import { Component, Vue } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';

interface PageOption {
  count: number;
  max: number;
  min: number;
  current: number;
}

@Component({
  components: {
    AccountIcon,
    CommonButton,
  },
})
export default class PullRequests extends Vue {
  private commonButtonColorCreate: string = 'light-blue';
  private commonButtonIconClass: string = 'plus';
  private items: Array<object> = [
    {
      id: '#1',
      subject: 'Remove runner after group changes ',
      relatedTask: 'THEORY137',
      registeredPerson: 'セオリー太郎',
      currentResponsiblePerson: 'セオリー次郎',
      status: 'Open',
      createdDate: '2020/09/21 21:11',
      updateDate: '2020/09/21 21:11',
    },
    {
      id: '#2',
      subject: 'ボタンの色・デザインの統一',
      relatedTask: 'THEORY137',
      registeredPerson: 'セオリー太郎',
      currentResponsiblePerson: 'セオリー次郎',
      status: 'Open',
      createdDate: '2020/09/21 21:11',
      updateDate: '2020/09/21 21:11',
    },
    {
      id: '#3',
      subject: 'ボタンの色・デザインの統一',
      relatedTask: 'THEORY137',
      registeredPerson: 'セオリー太郎',
      currentResponsiblePerson: 'セオリー次郎',
      status: 'Open',
      createdDate: '2020/09/21 21:11',
      updateDate: '2020/09/21 21:11',
    },
    {
      id: '#4',
      subject: 'ボタンの色・デザインの統一',
      relatedTask: 'THEORY137',
      registeredPerson: 'セオリー太郎',
      currentResponsiblePerson: 'セオリー次郎',
      status: 'Open',
      createdDate: '2020/09/21 21:11',
      updateDate: '2020/09/21 21:11',
    },
    {
      id: '#5',
      subject: 'ボタンの色・デザインの統一',
      relatedTask: 'THEORY137',
      registeredPerson: 'セオリー太郎',
      currentResponsiblePerson: 'セオリー次郎',
      status: 'Open',
      createdDate: '2020/09/21 21:11',
      updateDate: '2020/09/21 21:11',
    },
    {
      id: '#6',
      subject: 'Remove runner after group changes ',
      relatedTask: 'THEORY137',
      registeredPerson: 'セオリー太郎',
      currentResponsiblePerson: 'セオリー次郎',
      status: 'Open',
      createdDate: '2020/09/21 21:11',
      updateDate: '2020/09/21 21:11',
    },
    {
      id: '#7',
      subject: 'Remove runner after group changes ',
      relatedTask: 'THEORY137',
      registeredPerson: 'セオリー太郎',
      currentResponsiblePerson: 'セオリー次郎',
      status: 'Open',
      createdDate: '2020/09/21 21:11',
      updateDate: '2020/09/21 21:11',
    },
  ];
  private headers = [
    {
      text: '',
      align: 'start',
      filterable: false,
      value: 'id',
    },
    {
      text: '関連課題',
      align: 'start',
      filterable: false,
      value: 'relatedTask',
    },
    {
      text: '登録者',
      align: 'start',
      filterable: false,
      value: 'registeredPerson',
    },
    {
      text: '担当者',
      align: 'start',
      filterable: false,
      value: 'currentResponsiblePerson',
    },
  ];
  private listItems() {
    const pullRequests = this.items;
    return pullRequests;
  }
  private pageOption: PageOption = {
    count: 20,
    max: 5,
    min: 1,
    current: 1,
  };
}
